// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: qGIhF9oXFLxB
import * as React from "react";
import {
  PlasmicIcon as PlasmicIcon__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as pp from "@plasmicapp/react-web";
import SelectBizClass__Overlay from "../../SelectBizClass__Overlay"; // plasmic-import: C2zXvp_eryUt/component
import SelectBizClass__Option from "../../SelectBizClass__Option"; // plasmic-import: nx8mGPvcCSVf/component
import SelectBizClass__OptionGroup from "../../SelectBizClass__OptionGroup"; // plasmic-import: FPoEbRRmg-Wd/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSelectBizClass.module.css"; // plasmic-import: qGIhF9oXFLxB/css
import ChevronDownSvgIcon from "./icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: B3NfmvoQPNM4/icon
import ChevronUpSvgIcon from "./icons/PlasmicIcon__ChevronUpSvg"; // plasmic-import: NOXSpKy5wnrC/icon

createPlasmicElementProxy;

export const PlasmicSelectBizClass__VariantProps = new Array(
  "showPlaceholder",
  "isOpen",
  "isDisabled",
  "color"
);

export const PlasmicSelectBizClass__ArgProps = new Array(
  "selectedContent",
  "placeholder",
  "children",
  "value",
  "name",
  "aria-label",
  "aria-labelledby",
  "options",
  "onChange"
);

const PlasmicSelectBizClassContext = React.createContext(undefined);

const $$ = {};

function PlasmicSelectBizClass__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "showPlaceholder",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showPlaceholder
      },
      {
        path: "isOpen",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isOpen
      },
      {
        path: "isDisabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isDisabled
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      },
      {
        path: "value",
        type: "writable",
        variableType: "text",
        valueProp: "value",
        onChangeProp: "onChange"
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <PlasmicSelectBizClassContext.Provider value={{ variants, args }}>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          sty.root,
          {
            [sty.rootcolor_clear]: hasVariant($state, "color", "clear"),
            [sty.rootcolor_softBlue]: hasVariant($state, "color", "softBlue"),
            [sty.rootcolor_softCyan]: hasVariant($state, "color", "softCyan"),
            [sty.rootcolor_softGreen]: hasVariant($state, "color", "softGreen"),
            [sty.rootcolor_softOrange]: hasVariant(
              $state,
              "color",
              "softOrange"
            ),
            [sty.rootcolor_softPink]: hasVariant($state, "color", "softPink"),
            [sty.rootcolor_softPurple]: hasVariant(
              $state,
              "color",
              "softPurple"
            ),
            [sty.rootcolor_softRed]: hasVariant($state, "color", "softRed"),
            [sty.rootcolor_softYellow]: hasVariant(
              $state,
              "color",
              "softYellow"
            ),
            [sty.rootisOpen]: hasVariant($state, "isOpen", "isOpen")
          }
        )}
      >
        <button
          data-plasmic-name={"trigger"}
          data-plasmic-override={overrides.trigger}
          className={classNames(
            projectcss.all,
            projectcss.button,
            sty.trigger,
            {
              [sty.triggercolor_clear]: hasVariant($state, "color", "clear"),
              [sty.triggercolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.triggercolor_softCyan]: hasVariant(
                $state,
                "color",
                "softCyan"
              ),
              [sty.triggercolor_softGray]: hasVariant(
                $state,
                "color",
                "softGray"
              ),
              [sty.triggercolor_softGreen]: hasVariant(
                $state,
                "color",
                "softGreen"
              ),
              [sty.triggercolor_softOrange]: hasVariant(
                $state,
                "color",
                "softOrange"
              ),
              [sty.triggercolor_softPink]: hasVariant(
                $state,
                "color",
                "softPink"
              ),
              [sty.triggercolor_softPurple]: hasVariant(
                $state,
                "color",
                "softPurple"
              ),
              [sty.triggercolor_softRed]: hasVariant(
                $state,
                "color",
                "softRed"
              ),
              [sty.triggercolor_softYellow]: hasVariant(
                $state,
                "color",
                "softYellow"
              ),
              [sty.triggerisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.triggerisOpen]: hasVariant($state, "isOpen", "isOpen"),
              [sty.triggershowPlaceholder]: hasVariant(
                $state,
                "showPlaceholder",
                "showPlaceholder"
              )
            }
          )}
          disabled={
            hasVariant($state, "isDisabled", "isDisabled") ? true : undefined
          }
          ref={ref => {
            $refs["trigger"] = ref;
          }}
        >
          <div
            data-plasmic-name={"contentContainer"}
            data-plasmic-override={overrides.contentContainer}
            className={classNames(projectcss.all, sty.contentContainer, {
              [sty.contentContainercolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.contentContainerisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.contentContainershowPlaceholder]: hasVariant(
                $state,
                "showPlaceholder",
                "showPlaceholder"
              )
            })}
          >
            {(
              hasVariant($state, "showPlaceholder", "showPlaceholder")
                ? false
                : true
            )
              ? renderPlasmicSlot({
                  defaultContents: "Selected",
                  value: args.selectedContent,
                  className: classNames(sty.slotTargetSelectedContent, {
                    [sty.slotTargetSelectedContentcolor_softBlue]: hasVariant(
                      $state,
                      "color",
                      "softBlue"
                    ),
                    [sty.slotTargetSelectedContentcolor_softCyan]: hasVariant(
                      $state,
                      "color",
                      "softCyan"
                    ),
                    [sty.slotTargetSelectedContentcolor_softGreen]: hasVariant(
                      $state,
                      "color",
                      "softGreen"
                    ),
                    [sty.slotTargetSelectedContentcolor_softOrange]: hasVariant(
                      $state,
                      "color",
                      "softOrange"
                    ),
                    [sty.slotTargetSelectedContentcolor_softPink]: hasVariant(
                      $state,
                      "color",
                      "softPink"
                    ),
                    [sty.slotTargetSelectedContentcolor_softPurple]: hasVariant(
                      $state,
                      "color",
                      "softPurple"
                    ),
                    [sty.slotTargetSelectedContentcolor_softRed]: hasVariant(
                      $state,
                      "color",
                      "softRed"
                    ),
                    [sty.slotTargetSelectedContentcolor_softYellow]: hasVariant(
                      $state,
                      "color",
                      "softYellow"
                    ),
                    [sty.slotTargetSelectedContentisDisabled]: hasVariant(
                      $state,
                      "isDisabled",
                      "isDisabled"
                    ),
                    [sty.slotTargetSelectedContentisOpen]: hasVariant(
                      $state,
                      "isOpen",
                      "isOpen"
                    ),
                    [sty.slotTargetSelectedContentshowPlaceholder]: hasVariant(
                      $state,
                      "showPlaceholder",
                      "showPlaceholder"
                    )
                  })
                })
              : null}
            {(
              hasVariant($state, "showPlaceholder", "showPlaceholder")
                ? true
                : false
            )
              ? renderPlasmicSlot({
                  defaultContents: "Select\u2026",
                  value: args.placeholder,
                  className: classNames(sty.slotTargetPlaceholder, {
                    [sty.slotTargetPlaceholdercolor_softBlue]: hasVariant(
                      $state,
                      "color",
                      "softBlue"
                    ),
                    [sty.slotTargetPlaceholdercolor_softBlue_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softBlue"),
                    [sty.slotTargetPlaceholdercolor_softCyan_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softCyan"),
                    [sty.slotTargetPlaceholdercolor_softGreen_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softGreen"),
                    [sty.slotTargetPlaceholdercolor_softOrange_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softOrange"),
                    [sty.slotTargetPlaceholdercolor_softPink_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softPink"),
                    [sty.slotTargetPlaceholdercolor_softRed_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softRed"),
                    [sty.slotTargetPlaceholdercolor_softYellow_showPlaceholder]:
                      hasVariant(
                        $state,
                        "showPlaceholder",
                        "showPlaceholder"
                      ) && hasVariant($state, "color", "softYellow"),
                    [sty.slotTargetPlaceholdershowPlaceholder]: hasVariant(
                      $state,
                      "showPlaceholder",
                      "showPlaceholder"
                    ),
                    [sty.slotTargetPlaceholdershowPlaceholder_color_softPurple]:
                      hasVariant($state, "color", "softPurple") &&
                      hasVariant($state, "showPlaceholder", "showPlaceholder")
                  })
                })
              : null}
          </div>
          <PlasmicIcon__
            data-plasmic-name={"dropdownIcon"}
            data-plasmic-override={overrides.dropdownIcon}
            PlasmicIconType={
              hasVariant($state, "isOpen", "isOpen")
                ? ChevronUpSvgIcon
                : ChevronDownSvgIcon
            }
            className={classNames(projectcss.all, sty.dropdownIcon, {
              [sty.dropdownIconcolor_softBlue]: hasVariant(
                $state,
                "color",
                "softBlue"
              ),
              [sty.dropdownIconcolor_softCyan]: hasVariant(
                $state,
                "color",
                "softCyan"
              ),
              [sty.dropdownIconcolor_softGray]: hasVariant(
                $state,
                "color",
                "softGray"
              ),
              [sty.dropdownIconcolor_softGreen]: hasVariant(
                $state,
                "color",
                "softGreen"
              ),
              [sty.dropdownIconcolor_softOrange]: hasVariant(
                $state,
                "color",
                "softOrange"
              ),
              [sty.dropdownIconcolor_softPink]: hasVariant(
                $state,
                "color",
                "softPink"
              ),
              [sty.dropdownIconcolor_softPurple]: hasVariant(
                $state,
                "color",
                "softPurple"
              ),
              [sty.dropdownIconcolor_softRed]: hasVariant(
                $state,
                "color",
                "softRed"
              ),
              [sty.dropdownIconcolor_softYellow]: hasVariant(
                $state,
                "color",
                "softYellow"
              ),
              [sty.dropdownIconisDisabled]: hasVariant(
                $state,
                "isDisabled",
                "isDisabled"
              ),
              [sty.dropdownIconisOpen]: hasVariant($state, "isOpen", "isOpen")
            })}
            role={"img"}
          />
        </button>
        {(hasVariant($state, "isOpen", "isOpen") ? true : false) ? (
          <SelectBizClass__Overlay
            data-plasmic-name={"overlay"}
            data-plasmic-override={overrides.overlay}
            className={classNames("__wab_instance", sty.overlay, {
              [sty.overlayisOpen]: hasVariant($state, "isOpen", "isOpen")
            })}
            relativePlacement={"bottom"}
          >
            <div
              data-plasmic-name={"optionsContainer"}
              data-plasmic-override={overrides.optionsContainer}
              className={classNames(projectcss.all, sty.optionsContainer, {
                [sty.optionsContainerisOpen]: hasVariant(
                  $state,
                  "isOpen",
                  "isOpen"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <React.Fragment>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__cxbgN
                      )}
                      value={"9ed38146-7d6f-11e3-89d6-5404a6144203"}
                    >
                      {"Marketing"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__rNzBl
                      )}
                      value={"9ed46b9e-7d6f-11e3-9fec-5404a6144203"}
                    >
                      {"Graphic Design"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__upwiM
                      )}
                      textValue={""}
                      value={"9ed3a851-7d6f-11e3-92a4-5404a6144203"}
                    >
                      {"Software"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__iBtCp
                      )}
                      textValue={""}
                      value={"9ed3cf60-7d6f-11e3-a80d-5404a6144203"}
                    >
                      {"Accounting"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___3GhJt
                      )}
                      value={"9ed3814f-7d6f-11e3-aaf6-5404a6144203"}
                    >
                      {"Wholesale"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__gtcG2
                      )}
                      value={"9ed3813d-7d6f-11e3-bd65-5404a6144203"}
                    >
                      {"Education"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__ySjU2
                      )}
                      value={"9ed3813c-7d6f-11e3-82cc-5404a6144203"}
                    >
                      {"Consulting"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__jaMmo
                      )}
                      value={"9ed3cf63-7d6f-11e3-b50c-5404a6144203"}
                    >
                      {"Investment Service"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__r1NGu
                      )}
                      value={"9ed46b95-7d6f-11e3-970b-5404a6144203"}
                    >
                      {"eCommerce Service"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___6ToeX
                      )}
                      value={"9ed3a853-7d6f-11e3-a35d-5404a6144203"}
                    >
                      {"Web Hosting and Design"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__pUQo)}
                      value={"9ed4449a-7d6f-11e3-a380-5404a6144203"}
                    >
                      {"Retailer"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__egdAy
                      )}
                      value={"9ed41d7a-7d6f-11e3-ae21-5404a6144203"}
                    >
                      {"Construction"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__zmWMr
                      )}
                      value={"9ed46ba6-7d6f-11e3-ae95-5404a6144203"}
                    >
                      {"Legal Services"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__xbIRe
                      )}
                      value={"9ed35a38-7d6f-11e3-a24f-5404a6144203"}
                    >
                      {"Publishing"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option___2EnDj
                      )}
                      value={"9ed444a6-7d6f-11e3-ad1c-5404a6144203"}
                    >
                      {"Photography"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__jue0K
                      )}
                      value={"9ed492a5-7d6f-11e3-8d8f-5404a6144203"}
                    >
                      {"Telecommunication Services"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__o5M6)}
                      value={"9ed4449f-7d6f-11e3-b867-5404a6144203"}
                    >
                      {"Public Relations"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__v3GAn
                      )}
                      value={"9ed46ba3-7d6f-11e3-9efe-5404a6144203"}
                    >
                      {"Insurance"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__nCm3)}
                      value={"9ed492ab-7d6f-11e3-9907-5404a6144203"}
                    >
                      {"Real Estate"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__s7EyG
                      )}
                      value={"9ed3814e-7d6f-11e3-9087-5404a6144203"}
                    >
                      {"Secretarial Support"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__fci3E
                      )}
                      value={"9ed46b9a-7d6f-11e3-a11b-5404a6144203"}
                    >
                      {"Event Planning Support"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__xHZ)}
                      value={"9ed4b9bb-7d6f-11e3-af9f-5404a6144203"}
                    >
                      {"Travel Agency"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__feZ2)}
                      value={"9ed3f679-7d6f-11e3-a884-5404a6144203"}
                    >
                      {"Gifting"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames("__wab_instance", sty.option__aVV0)}
                      value={"9ed38143-7d6f-11e3-bc00-5404a6144203"}
                    >
                      {"Recruiting Services"}
                    </SelectBizClass__Option>
                    <SelectBizClass__Option
                      className={classNames(
                        "__wab_instance",
                        sty.option__aIxEj
                      )}
                      value={"9ed3cf5a-7d6f-11e3-9a99-5404a6144203"}
                    >
                      {"Digital Media"}
                    </SelectBizClass__Option>
                  </React.Fragment>
                ),

                value: args.children
              })}
            </div>
          </SelectBizClass__Overlay>
        ) : null}
      </div>
    </PlasmicSelectBizClassContext.Provider>
  );
}

function useBehavior(props, ref) {
  if (!("options" in props)) {
    if (!("children" in props)) {
      props = {
        ...props,
        children: (
          <React.Fragment>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__cxbgN)}
              value={"9ed38146-7d6f-11e3-89d6-5404a6144203"}
            >
              {"Marketing"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__rNzBl)}
              value={"9ed46b9e-7d6f-11e3-9fec-5404a6144203"}
            >
              {"Graphic Design"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__upwiM)}
              textValue={""}
              value={"9ed3a851-7d6f-11e3-92a4-5404a6144203"}
            >
              {"Software"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__iBtCp)}
              textValue={""}
              value={"9ed3cf60-7d6f-11e3-a80d-5404a6144203"}
            >
              {"Accounting"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option___3GhJt)}
              value={"9ed3814f-7d6f-11e3-aaf6-5404a6144203"}
            >
              {"Wholesale"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__gtcG2)}
              value={"9ed3813d-7d6f-11e3-bd65-5404a6144203"}
            >
              {"Education"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__ySjU2)}
              value={"9ed3813c-7d6f-11e3-82cc-5404a6144203"}
            >
              {"Consulting"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__jaMmo)}
              value={"9ed3cf63-7d6f-11e3-b50c-5404a6144203"}
            >
              {"Investment Service"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__r1NGu)}
              value={"9ed46b95-7d6f-11e3-970b-5404a6144203"}
            >
              {"eCommerce Service"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option___6ToeX)}
              value={"9ed3a853-7d6f-11e3-a35d-5404a6144203"}
            >
              {"Web Hosting and Design"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__pUQo)}
              value={"9ed4449a-7d6f-11e3-a380-5404a6144203"}
            >
              {"Retailer"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__egdAy)}
              value={"9ed41d7a-7d6f-11e3-ae21-5404a6144203"}
            >
              {"Construction"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__zmWMr)}
              value={"9ed46ba6-7d6f-11e3-ae95-5404a6144203"}
            >
              {"Legal Services"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__xbIRe)}
              value={"9ed35a38-7d6f-11e3-a24f-5404a6144203"}
            >
              {"Publishing"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option___2EnDj)}
              value={"9ed444a6-7d6f-11e3-ad1c-5404a6144203"}
            >
              {"Photography"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__jue0K)}
              value={"9ed492a5-7d6f-11e3-8d8f-5404a6144203"}
            >
              {"Telecommunication Services"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__o5M6)}
              value={"9ed4449f-7d6f-11e3-b867-5404a6144203"}
            >
              {"Public Relations"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__v3GAn)}
              value={"9ed46ba3-7d6f-11e3-9efe-5404a6144203"}
            >
              {"Insurance"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__nCm3)}
              value={"9ed492ab-7d6f-11e3-9907-5404a6144203"}
            >
              {"Real Estate"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__s7EyG)}
              value={"9ed3814e-7d6f-11e3-9087-5404a6144203"}
            >
              {"Secretarial Support"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__fci3E)}
              value={"9ed46b9a-7d6f-11e3-a11b-5404a6144203"}
            >
              {"Event Planning Support"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__xHZ)}
              value={"9ed4b9bb-7d6f-11e3-af9f-5404a6144203"}
            >
              {"Travel Agency"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__feZ2)}
              value={"9ed3f679-7d6f-11e3-a884-5404a6144203"}
            >
              {"Gifting"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__aVV0)}
              value={"9ed38143-7d6f-11e3-bc00-5404a6144203"}
            >
              {"Recruiting Services"}
            </SelectBizClass__Option>
            <SelectBizClass__Option
              className={classNames("__wab_instance", sty.option__aIxEj)}
              value={"9ed3cf5a-7d6f-11e3-9a99-5404a6144203"}
            >
              {"Digital Media"}
            </SelectBizClass__Option>
          </React.Fragment>
        )
      };
    }
  }
  return pp.useSelect(
    PlasmicSelectBizClass,
    props,
    {
      ...{
        isOpenVariant: { group: "isOpen", variant: "isOpen" },
        placeholderVariant: {
          group: "showPlaceholder",
          variant: "showPlaceholder"
        },
        isDisabledVariant: { group: "isDisabled", variant: "isDisabled" },
        triggerContentSlot: "selectedContent",
        optionsSlot: "children",
        placeholderSlot: "placeholder",
        root: "root",
        trigger: "trigger",
        overlay: "overlay",
        optionsContainer: "optionsContainer"
      },
      OptionComponent: SelectBizClass__Option,
      OptionGroupComponent: SelectBizClass__OptionGroup
    },
    ref
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "trigger",
    "contentContainer",
    "dropdownIcon",
    "overlay",
    "optionsContainer"
  ],

  trigger: ["trigger", "contentContainer", "dropdownIcon"],
  contentContainer: ["contentContainer"],
  dropdownIcon: ["dropdownIcon"],
  overlay: ["overlay", "optionsContainer"],
  optionsContainer: ["optionsContainer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSelectBizClass__ArgProps,
          internalVariantPropNames: PlasmicSelectBizClass__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSelectBizClass__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSelectBizClass";
  } else {
    func.displayName = `PlasmicSelectBizClass.${nodeName}`;
  }
  return func;
}

export const PlasmicSelectBizClass = Object.assign(
  // Top-level PlasmicSelectBizClass renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    trigger: makeNodeComponent("trigger"),
    contentContainer: makeNodeComponent("contentContainer"),
    dropdownIcon: makeNodeComponent("dropdownIcon"),
    overlay: makeNodeComponent("overlay"),
    optionsContainer: makeNodeComponent("optionsContainer"),
    // Metadata about props expected for PlasmicSelectBizClass
    internalVariantProps: PlasmicSelectBizClass__VariantProps,
    internalArgProps: PlasmicSelectBizClass__ArgProps,
    // Context for sub components
    Context: PlasmicSelectBizClassContext,
    useBehavior
  }
);

export default PlasmicSelectBizClass;
/* prettier-ignore-end */
